<app-navbar [ShowTranslationDropdown]="true" [showTimeZone]="false" [showCompanySelector]="false"> </app-navbar>
<app-sidenav [socialFooter]="true"></app-sidenav>
<app-tour></app-tour>
